import { render, staticRenderFns } from "./DashboardCtxMenu.vue?vue&type=template&id=266a4fd6&scoped=true&"
import script from "./DashboardCtxMenu.vue?vue&type=script&lang=js&"
export * from "./DashboardCtxMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266a4fd6",
  null
  
)

export default component.exports